import { IconName } from './icons';

export const indicatorTypes = [
  'todo',
  'empty',
  'done',
  'correct',
  'incorrect',
  'loading',
  'predefined',
] as const;

export type IndicatorType = (typeof indicatorTypes)[number];

export const indicatorSizes = ['small', 'medium', 'large'] as const;

export type IndicatorSize = (typeof indicatorSizes)[number];

export const indicatorIconMap: Record<IndicatorType, IconName | undefined> = {
  todo: undefined,
  empty: undefined,
  done: 'check',
  correct: 'check',
  incorrect: 'close',
  loading: 'loading',
  predefined: 'check-solid',
};

export const indicatorSizeMap: Record<IndicatorSize, number> = {
  small: 16,
  medium: 24,
  large: 32,
};

export const indicatorIcon = (type: IndicatorType) => indicatorIconMap[type];
